import cx from 'classnames'

import { useState, useEffect } from 'react'

import type { ContainerProps } from '@/components/Container'
import { Image } from '@/components/Image'
import { BodyM, HeadingL } from '@/components/Typography'

import type { TitleProps } from '@/models'

import { useConsultData } from '../hooks/useConsultData'

import type { ConsultData } from '../types'

import { FreeDocumentConsultingForms } from './FreeDocumentConsultingForms'

import { MediaWithFormsContainer } from './styles'

type ContentPosition = 'left' | 'right'

interface Props {
  id?: string
  title: TitleProps
  subtitle: string
  isPremium: boolean
  image?: {
    url: string
    alt?: string
  }
  position: ContentPosition
}

const MediaWithFormsBlock = ({ id, title, subtitle, image, position }: Props) => {
  const containerProps: ContainerProps = {
    id,
    backgroundColor: 'custom',
    backgroundColorHex: '#FAEFF4',
  }

  const [consultData, setConsultData] = useState<ConsultData>()

  const hookConsultData = useConsultData()

  useEffect(() => {
    hookConsultData.then((consultData) => setConsultData(consultData))
  }, [])

  return (
    <MediaWithFormsContainer
      {...containerProps}
      contentClassName={cx('media-with-forms__content', {
        [`media-with-forms__content--${position}`]: position,
      })}
    >
      {!!image && (
        <div className="media-with-forms__image">
          <Image source={image.url} alt={image.alt || ''} width={380} height={460} />
        </div>
      )}

      <div className="media-with-forms__content-wrapper">
        {!!title && (
          <HeadingL tag="h1" className="media-with-forms__title">
            {title}
          </HeadingL>
        )}

        {!consultData?.isPremium && !!subtitle && (
          <BodyM className="media-with-forms__subtitle" tag="div" html={subtitle} />
        )}

        {consultData?.isPremium && !!subtitle && (
          <BodyM
            className="media-with-forms__subtitle"
            tag="div"
            html="Aqui você pode consultar a situação cadastral de terceiros por apenas <s>R$35,00</s> <b>R$20,00 a consulta</b>. O resultado sai na hora!"
          />
        )}

        <FreeDocumentConsultingForms consultData={consultData} />
      </div>
    </MediaWithFormsContainer>
  )
}

export default MediaWithFormsBlock
